var _path, _path2, _path3, _rect, _rect2, _rect3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg227(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 32C42 40.8366 34.8366 48 26 48C17.1634 48 10 40.8366 10 32C10 23.1634 17.1634 16 26 16C34.8366 16 42 23.1634 42 32Z",
    fill: "#E6E7E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54 36C54 42.6274 48.6274 48 42 48C35.3726 48 30 42.6274 30 36C30 29.3726 35.3726 24 42 24C48.6274 24 54 29.3726 54 36Z",
    fill: "#E6E7E8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26 40H42V48H26V40Z",
    fill: "#E6E7E8"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18.7464,
    y: 49,
    width: 2,
    height: 12,
    rx: 1,
    fill: "#E6E7E8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24.3923,
    y: 51.0837,
    width: 2,
    height: 12,
    rx: 1,
    transform: "rotate(60 24.3923 51.0837)",
    fill: "#E6E7E8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14.0503,
    y: 52.8661,
    width: 2,
    height: 12,
    rx: 1,
    transform: "rotate(-60 14.0503 52.8661)",
    fill: "#E6E7E8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27 53V51H43V53H27Z",
    fill: "#E3E3E3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43 53C43.394 53 43.7841 52.9224 44.1481 52.7716C44.512 52.6209 44.8427 52.3999 45.1213 52.1213C45.3999 51.8427 45.6209 51.512 45.7716 51.148C45.9224 50.7841 46 50.394 46 50C46 49.606 45.9224 49.2159 45.7716 48.8519C45.6209 48.488 45.3999 48.1573 45.1213 47.8787C44.8427 47.6001 44.512 47.3791 44.1481 47.2284C43.7841 47.0776 43.394 47 43 47L43 48.9976C43.1316 48.9976 43.262 49.0235 43.3836 49.0739C43.5052 49.1243 43.6157 49.1981 43.7088 49.2912C43.8019 49.3843 43.8757 49.4948 43.9261 49.6164C43.9765 49.738 44.0024 49.8684 44.0024 50C44.0024 50.1316 43.9765 50.262 43.9261 50.3836C43.8757 50.5052 43.8019 50.6157 43.7088 50.7088C43.6157 50.8019 43.5052 50.8757 43.3836 50.9261C43.262 50.9765 43.1316 51.0024 43 51.0024V53Z",
    fill: "#E3E3E3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27 54V56H47V54H27Z",
    fill: "#E3E3E3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M47 54C47.394 54 47.7841 54.0776 48.1481 54.2284C48.512 54.3791 48.8427 54.6001 49.1213 54.8787C49.3999 55.1573 49.6209 55.488 49.7716 55.8519C49.9224 56.2159 50 56.606 50 57C50 57.394 49.9224 57.7841 49.7716 58.1481C49.6209 58.512 49.3999 58.8427 49.1213 59.1213C48.8427 59.3999 48.512 59.6209 48.1481 59.7716C47.7841 59.9224 47.394 60 47 60L47 58.0024C47.1316 58.0024 47.262 57.9765 47.3836 57.9261C47.5052 57.8757 47.6157 57.8019 47.7088 57.7088C47.8019 57.6157 47.8757 57.5052 47.9261 57.3836C47.9765 57.262 48.0024 57.1316 48.0024 57C48.0024 56.8684 47.9765 56.738 47.9261 56.6164C47.8757 56.4948 47.8019 56.3843 47.7088 56.2912C47.6157 56.1981 47.5052 56.1243 47.3836 56.0739C47.262 56.0235 47.1316 55.9976 47 55.9976V54Z",
    fill: "#E3E3E3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27 57V59H41V57H27Z",
    fill: "#E3E3E3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M41 57C41.394 57 41.7841 57.0776 42.1481 57.2284C42.512 57.3791 42.8427 57.6001 43.1213 57.8787C43.3999 58.1573 43.6209 58.488 43.7716 58.8519C43.9224 59.2159 44 59.606 44 60C44 60.394 43.9224 60.7841 43.7716 61.1481C43.6209 61.512 43.3999 61.8427 43.1213 62.1213C42.8427 62.3999 42.512 62.6209 42.148 62.7716C41.7841 62.9224 41.394 63 41 63L41 61.0024C41.1316 61.0024 41.262 60.9765 41.3836 60.9261C41.5052 60.8757 41.6157 60.8019 41.7088 60.7088C41.8019 60.6157 41.8757 60.5052 41.9261 60.3836C41.9765 60.262 42.0024 60.1316 42.0024 60C42.0024 59.8684 41.9765 59.738 41.9261 59.6164C41.8757 59.4948 41.8019 59.3843 41.7088 59.2912C41.6157 59.1981 41.5052 59.1243 41.3836 59.0739C41.262 59.0235 41.1316 58.9976 41 58.9976V57Z",
    fill: "#E3E3E3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg227);
export default __webpack_public_path__ + "static/media/227.4a754022bb295818e6095af58084dde5.svg";
export { ForwardRef as ReactComponent };